'use client';

import { useListingSearchStore } from '@/store';
import { ErrorBoundary } from '@/components/base/Layout/ErrorBoundary';
import { usePopupWizard } from '@/component/Modal';
import {
  SearchListingButton,
  SearchListingDateField,
  SearchListingGuestsField,
  SearchListingLocationField,
} from './fields';
import { SearchListingDivider } from './components/Divider';
import { SearchListingContainer } from './components/SearchListingContainer';

export const SearchListing = () => {
  const { currentStep, onSetStep } = usePopupWizard([
    'location',
    'date',
    'guests',
  ]);
  const theme = 'compact';
  const { focusField } = useListingSearchStore();
  return (
    <ErrorBoundary tags={{ feature: 'search_listing' }}>
      <SearchListingContainer isFocused={Boolean(focusField)}>
        <SearchListingLocationField
          currentStep={currentStep}
          onSetStep={onSetStep}
          theme={theme}
        />
        <SearchListingDivider />
        <SearchListingDateField
          currentStep={currentStep}
          onSetStep={onSetStep}
          theme={theme}
        />
        <SearchListingDivider />
        <SearchListingGuestsField
          currentStep={currentStep}
          onSetStep={onSetStep}
          theme={theme}
        />
        <SearchListingButton theme={theme} pageName="results page" />
      </SearchListingContainer>
    </ErrorBoundary>
  );
};
